import { FC } from "react";
import { Box, Typography } from "@mui/material";

const ArrowUpIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12 19V5M12 5L5 12M12 5L19 12"
      stroke="#fff"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

interface NewPostsBannerProps {
  count: number;
  onClick: () => void;
}

const NewPostsBanner: FC<NewPostsBannerProps> = ({ count, onClick }) => {
  if (count <= 0) return null;

  return (
    <Box
      onClick={onClick}
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        gap: "6px",
        margin: "12px auto",
        padding: "8px 16px",
        width: "fit-content",
        borderRadius: "20px",
        backgroundColor: "#2A85FF",
        cursor: "pointer",
        boxShadow: "0 4px 12px rgba(42, 133, 255, 0.35)",
        userSelect: "none",
        "&:hover": { backgroundColor: "#1D6FE0" },
      }}
    >
      <ArrowUpIcon />
      <Typography
        sx={{
          fontFamily: "Inter",
          fontWeight: 600,
          fontSize: "14px",
          color: "#fff",
          whiteSpace: "nowrap",
        }}
      >
        {count} new {count === 1 ? "post" : "posts"}
      </Typography>
    </Box>
  );
};

export default NewPostsBanner;
